import React, { useEffect, useState } from 'react'

import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';
import { useNavigate } from "react-router-dom"



import Loader from '../../../utils/Loader';

const ChitDetailsEdit = ({ chitData, close }) => {

  
  const [formData, setFormData] = useState({
    customer_id: chitData.customer_id,
    active_plan_id: chitData.active_plan_id,
    month: chitData.month,
    payable_amount: chitData.payable_amount,
    cash_payment: chitData.cash_payment,
    online_payment: chitData.online_payment,
    payment_status: chitData.payment_status,
    amount_received: chitData.amount_received,
    pending_amount: chitData.pending_amount,
  });
  const [customerId, setCustomerId] = useState([])
  const [activePlan, setActivePlan] = useState([]);
  const [plan, SetPlan] = useState([])
  const [loading, setLoading] = useState(true)
  const [selectCustomer, setSelectCustomer] = useState([]);
  const navigate = useNavigate();
  const [validation, setvalidation] = useState([])


  const fetchData = async () => {
    setLoading(true)
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        "public/api/customers/filter/list",
        { headers: { Authorization: `Bearer ${token}` } }
      )
      const response1 = await axios.get(
        "public/api/active/list",
        { headers: { Authorization: `Bearer ${token}` } }
      )
    
      setCustomerId(response.data.data)
      setActivePlan(response1?.data?.plans)


    } catch (error) {
      if (error.response && error.response.status === 401) {
                localStorage.removeItem("token");
                navigate("/");
            }
            setvalidation(error.response.data);

     
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const options = customerId?.map((item) => ({
    label: item.name,
    value: item.id
  }));



  const handleChangeData = (selectedOption) => {

    // setSelectCustomer(selectedOption);
    setFormData((prevState) => ({
      ...prevState,
      customer_ids: selectedOption,
    }));
  };


    //   const handleChange = (e) => {
    //     const { name, value } = e.target;

    //     if(name === "payable_amount" || name === "online_payment"){

    //     }
    //     setFormData((prevState) => ({
    //         ...prevState,
    //         [name]: value,
    //     }));
    // };

const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prevState) => {
    const updatedData = {
      ...prevState,
      [name]: value,
    };

    // When cash_payment or online_payment changes, recalculate totals
    if (name === "cash_payment" || name === "online_payment") {
      const cash = parseFloat(updatedData.cash_payment) || 0;
      const online = parseFloat(updatedData.online_payment) || 0;
      const payable = parseFloat(updatedData.payable_amount) || 0;

      const totalReceived = cash + online;
      const pending = payable - totalReceived;

      updatedData.amount_received = totalReceived.toFixed(2);
      updatedData.pending_amount = pending >= 0 ? pending.toFixed(2) : "0.00"; // prevents negative values
    }

    return updatedData;
  });
};


    
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `public/api/chit/details/${chitData.id}`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
     
      close()
    } catch (error) {
      if (error.response.status === 401) {
        localStorage.removeItem("token");
        navigate("/");
      }
    } finally {
      setLoading(false)
    }

  }

  if (loading) {
    return (
      <>

        <div className="flex flex-col items-center justify-center min-h-screen space-y-4">
          <div className="w-16 h-16 border-4 border-dashed rounded-full animate-spin border-blue-500"></div>
          <p className="text-lg text-gray-600">Loading...</p>
        </div>

      </>
    );
  }

  return (
    <div className='p-6'>
     
      <div className="flex items-center justify-end  w-full">
        <button
          onClick={close}
          className="text-gray-500 hover:text-gray-700 focus:outline-none"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="black"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
      </div>

      <div className='flex flex-col items-center mt-6  '>


        <div className="bg-blue-500 text-white p-3  rounded-full">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="40" height="40" color="#000000" fill="none">
            <path d="M18.5 20V17.9704C18.5 16.7281 17.9407 15.5099 16.8103 14.9946C15.4315 14.3661 13.7779 14 12 14C10.2221 14 8.5685 14.3661 7.18968 14.9946C6.05927 15.5099 5.5 16.7281 5.5 17.9704V20" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <circle cx="12" cy="7.5" r="3.5" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle>
          </svg>
        </div>
        <h1 className='text-3xl font-bold mt-4'>Update Chit Details</h1>

        <p className="text-gray-600 mt-2 text-center">
          Complete the form below to add a new Chit Details to your chit fund.
          All fields marked with <span className="text-red-500">*</span> are required.
        </p>
      </div>
      <div className=' border-b-2 mt-4 '></div>

      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 mt-4 gap-6">

          {/* Name */}
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
              <span className='border bg-blue-100 rounded-full p-1'>

                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#bd10e0" fill="none">
                  <path d="M18.5 20V17.9704C18.5 16.7281 17.9407 15.5099 16.8103 14.9946C15.4315 14.3661 13.7779 14 12 14C10.2221 14 8.5685 14.3661 7.18968 14.9946C6.05927 15.5099 5.5 16.7281 5.5 17.9704V20" stroke="#bd10e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <circle cx="12" cy="7.5" r="3.5" stroke="#bd10e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle>
                </svg>
              </span> Customer Name  <span className='text-lg'> *</span>
            </label>

            <Select
              label="customer Name"
              name="customer_id"
              options={options}
              onChange={handleChangeData}
              value={options?.find(option => option.value === formData.customer_id) || formData.customer_id}
              isSearchable
              className='mt-2'

            />
            <p className="text-red-600 text-sm mt-1">{validation.errors?.customer_id}</p>
          </div>


          <div>
            <label htmlFor="active_plan_id"
              className="block text-sm font-medium text-gray-700 flex items-center gap-2"
            >

              <span className='border bg-red-100 rounded-full p-1'>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#d0021b" fill="none">
                  <defs />
                  <path fill="currentColor" d="M8.502,18.25 C8.502,18.25 8.495,18.25 8.492,18.25 C8.226,18.246 7.982,18.103 7.851,17.872 C6.173,14.936 5.015,14.771 5.002,14.77 C5.002,14.77 4.744,14.83 4.479,14.551 C4.213,14.271 4.252,13.953 4.252,13.953 C4.252,13.953 4.268,13.664 4.479,13.457 C4.69,13.25 5.002,13.25 5.002,13.25 C5.292,13.25 6.703,13.4 8.511,16.089 C10.148,13.595 14.575,7.343 18.741,5.797 C19.129,5.653 19.561,5.851 19.705,6.239 C19.849,6.627 19.651,7.059 19.263,7.203 C14.625,8.924 9.198,17.799 9.143,17.889 C9.007,18.113 8.764,18.25 8.502,18.25 Z" />
                </svg>
              </span>
              Active Plan {""}
              <span className='text-lg'> *</span>
            </label>
            <select
              id="active_plan_id"
              name="active_plan_id"
              value={formData.active_plan_id}
              onChange={handleChange}
              autoComplete="active_plan_id"
              className="block w-full mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            >
              <option value={""}>Select Plan</option>
             
              {activePlan?.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.plan.name}
                </option>
              ))}
            </select>
          </div>

          {/* Month */}
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
              <span className='border bg-blue-100 rounded-full p-1'>

                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#bd10e0" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.25 6C15.25 6.41 15.59 6.75 16 6.75C16.41 6.75 16.75 6.41 16.75 6V4.83087C17.9724 4.93384 18.7679 5.16789 19.3 5.69995C19.9651 6.3651 20.1646 7.44206 20.2244 9.25H3.77561C3.83542 7.44206 4.03486 6.3651 4.70001 5.69995C5.23207 5.16789 6.02761 4.93384 7.25 4.83087V6C7.25 6.41 7.59 6.75 8 6.75C8.41 6.75 8.75 6.41 8.75 6V4.76273C9.40827 4.75 10.1539 4.75 10.9995 4.75H11H13H13.0005C13.8461 4.75 14.5917 4.75 15.25 4.76273V6ZM20.36 4.64001C21.4772 5.75719 21.6964 7.26193 21.7395 9.87591C21.7464 9.91634 21.75 9.9578 21.75 10C21.75 10.0349 21.7475 10.0693 21.7428 10.1031C21.75 10.6805 21.75 11.3104 21.75 12V14C21.75 17.98 21.75 19.97 20.36 21.36C18.97 22.75 16.98 22.75 13 22.75H11C7.03 22.75 5.03001 22.75 3.64001 21.36C2.25001 19.97 2.25 17.98 2.25 14V12C2.25 11.3104 2.25 10.6805 2.25723 10.1031C2.25247 10.0693 2.25 10.0349 2.25 10C2.25 9.9578 2.2536 9.91634 2.26051 9.87591C2.30356 7.26193 2.52284 5.75719 3.64001 4.64001C4.50206 3.77797 5.59486 3.45054 7.25 3.32617V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V3.26274C9.42134 3.25 10.1671 3.25 11 3.25H13C13.8324 3.25 14.5783 3.25 15.25 3.26282V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V3.3265C18.4032 3.45112 19.4987 3.77873 20.36 4.64001ZM3.75184 10.75H20.2482C20.25 11.1404 20.25 11.5565 20.25 12V14C20.25 17.56 20.25 19.35 19.3 20.3C18.35 21.25 16.5602 21.25 13.0006 21.25H13H11H10.9994C7.43981 21.25 5.64996 21.25 4.70001 20.3C3.75001 19.35 3.75 17.56 3.75 14V12C3.75 11.5565 3.75 11.1404 3.75184 10.75ZM10.9998 18C10.9998 18.55 11.4498 19 11.9998 19C12.5498 19 12.9998 18.55 12.9998 18C12.9998 17.45 12.5498 17 11.9998 17C11.4398 17 10.9998 17.45 10.9998 18ZM7.00977 18C7.00977 18.55 7.45977 19 8.00977 19C8.55977 19 9.00977 18.55 9.00977 18C9.00977 17.45 8.55977 17 8.00977 17C7.44977 17 7.00977 17.45 7.00977 18ZM14.9998 14C14.9998 14.55 15.4498 15 15.9998 15C16.5498 15 16.9998 14.55 16.9998 14C16.9998 13.45 16.5498 13 15.9998 13C15.4398 13 14.9998 13.45 14.9998 14ZM10.9998 14C10.9998 14.55 11.4498 15 11.9998 15C12.5498 15 12.9998 14.55 12.9998 14C12.9998 13.45 12.5498 13 11.9998 13C11.4398 13 10.9998 13.45 10.9998 14ZM7.00977 14C7.00977 14.55 7.45977 15 8.00977 15C8.55977 15 9.00977 14.55 9.00977 14C9.00977 13.45 8.55977 13 8.00977 13C7.44977 13 7.00977 13.45 7.00977 14Z" fill="currentColor" />
                </svg>
              </span> Month  <span className='text-lg'> *</span>
            </label>

            <input
              id="month"
              name="month"
              type="text"
              placeholder="Enter Month"
              value={formData.month}
              disabled
              onChange={handleChange}
              autoComplete="month"
              className="block w-full mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
            <p className="text-red-600 text-sm mt-1">
              {validation.errors?.month}
            </p>
          </div>

          <div>
            <label htmlFor="payable_amount" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
              <span className='border bg-red-100 rounded-full p-1'>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#d0021b" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M21.65 18.65C20.55 19.75 19.03 19.75 16 19.75H8C4.97 19.75 3.44998 19.75 2.34998 18.65C1.25 17.55 1.25 15.9301 1.25 13.0002V13V11V10.9998C1.25 8.05993 1.25 6.44998 2.34998 5.35001C3.44998 4.25001 4.97 4.25 8 4.25H16C19.03 4.25 20.55 4.25001 21.65 5.35001C22.75 6.44998 22.75 8.06993 22.75 10.9998V11V13V13.0002C22.75 15.9401 22.75 17.55 21.65 18.65ZM8 5.75C7.52195 5.75 7.08752 5.75 6.69269 5.75401C6.37664 7.77652 4.77652 9.37667 2.75401 9.69272C2.75 10.0875 2.75 10.522 2.75 11V13C2.75 13.4778 2.75 13.9121 2.75401 14.3068C4.77667 14.6229 6.37688 16.2233 6.69276 18.246C7.08757 18.25 7.52198 18.25 8 18.25H16C16.4735 18.25 16.9043 18.25 17.2961 18.2461C17.5854 16.2062 19.2045 14.5904 21.246 14.3062C21.25 13.9117 21.25 13.4776 21.25 13V11C21.25 10.5206 21.25 10.0851 21.246 9.68933C19.2297 9.36307 17.627 7.75949 17.3079 5.75402C16.9129 5.75 16.4783 5.75 16 5.75H8ZM3.41003 6.41C3.76625 6.05379 4.31179 5.88983 5.15043 5.81436C4.85976 6.95737 3.95738 7.85977 2.81437 8.15045C2.88985 7.31178 3.05382 6.76622 3.41003 6.41ZM3.41003 17.59C3.05375 17.2337 2.88979 16.688 2.81433 15.8491C3.95751 16.1398 4.86 17.0424 5.15055 18.1856C4.31184 18.1102 3.76626 17.9462 3.41003 17.59ZM20.59 17.59C20.2313 17.9487 19.6807 18.1124 18.8322 18.1872C19.104 17.0257 20.0234 16.1092 21.1864 15.8414C21.1112 16.6847 20.9473 17.2326 20.59 17.59ZM20.59 6.41C20.9459 6.76592 21.1099 7.31086 21.1854 8.14834C20.0465 7.85462 19.1429 6.95143 18.8504 5.81444C19.6886 5.88994 20.2339 6.05391 20.59 6.41ZM8.25 12C8.25 14.07 9.93 15.75 12 15.75C14.07 15.75 15.75 14.07 15.75 12C15.75 9.93 14.07 8.25 12 8.25C9.93 8.25 8.25 9.93 8.25 12ZM9.75 12C9.75 10.76 10.76 9.75 12 9.75C13.24 9.75 14.25 10.76 14.25 12C14.25 13.24 13.24 14.25 12 14.25C10.76 14.25 9.75 13.24 9.75 12Z" fill="currentColor" />
                </svg>
              </span> Payable Amount
            </label>
            <input
              id="payable_amount"
              name="payable_amount"
              type="number"
              placeholder="Enter Payable Payment"
              value={formData.payable_amount}
              onChange={handleChange}
              autoComplete="payable_amount"
              disabled
              className="block w-full mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
            <p className="text-red-600 text-sm mt-1">
              {validation.errors?.payable_amount}
            </p>
          </div>

          {/* amount */}
          <div>
            <label htmlFor="cash_payment" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
              <span className='border bg-red-100 rounded-full p-1'>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#d0021b" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M21.65 18.65C20.55 19.75 19.03 19.75 16 19.75H8C4.97 19.75 3.44998 19.75 2.34998 18.65C1.25 17.55 1.25 15.9301 1.25 13.0002V13V11V10.9998C1.25 8.05993 1.25 6.44998 2.34998 5.35001C3.44998 4.25001 4.97 4.25 8 4.25H16C19.03 4.25 20.55 4.25001 21.65 5.35001C22.75 6.44998 22.75 8.06993 22.75 10.9998V11V13V13.0002C22.75 15.9401 22.75 17.55 21.65 18.65ZM8 5.75C7.52195 5.75 7.08752 5.75 6.69269 5.75401C6.37664 7.77652 4.77652 9.37667 2.75401 9.69272C2.75 10.0875 2.75 10.522 2.75 11V13C2.75 13.4778 2.75 13.9121 2.75401 14.3068C4.77667 14.6229 6.37688 16.2233 6.69276 18.246C7.08757 18.25 7.52198 18.25 8 18.25H16C16.4735 18.25 16.9043 18.25 17.2961 18.2461C17.5854 16.2062 19.2045 14.5904 21.246 14.3062C21.25 13.9117 21.25 13.4776 21.25 13V11C21.25 10.5206 21.25 10.0851 21.246 9.68933C19.2297 9.36307 17.627 7.75949 17.3079 5.75402C16.9129 5.75 16.4783 5.75 16 5.75H8ZM3.41003 6.41C3.76625 6.05379 4.31179 5.88983 5.15043 5.81436C4.85976 6.95737 3.95738 7.85977 2.81437 8.15045C2.88985 7.31178 3.05382 6.76622 3.41003 6.41ZM3.41003 17.59C3.05375 17.2337 2.88979 16.688 2.81433 15.8491C3.95751 16.1398 4.86 17.0424 5.15055 18.1856C4.31184 18.1102 3.76626 17.9462 3.41003 17.59ZM20.59 17.59C20.2313 17.9487 19.6807 18.1124 18.8322 18.1872C19.104 17.0257 20.0234 16.1092 21.1864 15.8414C21.1112 16.6847 20.9473 17.2326 20.59 17.59ZM20.59 6.41C20.9459 6.76592 21.1099 7.31086 21.1854 8.14834C20.0465 7.85462 19.1429 6.95143 18.8504 5.81444C19.6886 5.88994 20.2339 6.05391 20.59 6.41ZM8.25 12C8.25 14.07 9.93 15.75 12 15.75C14.07 15.75 15.75 14.07 15.75 12C15.75 9.93 14.07 8.25 12 8.25C9.93 8.25 8.25 9.93 8.25 12ZM9.75 12C9.75 10.76 10.76 9.75 12 9.75C13.24 9.75 14.25 10.76 14.25 12C14.25 13.24 13.24 14.25 12 14.25C10.76 14.25 9.75 13.24 9.75 12Z" fill="currentColor" />
                </svg>
              </span> Cash Payment
            </label>
            <input
              id="cash_payment"
              name="cash_payment"
              type="number"
              placeholder="Enter Cash Payment"
              value={formData.cash_payment}
              onChange={handleChange}
              autoComplete="cash_payment"
              className="block w-full mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
            <p className="text-red-600 text-sm mt-1">
              {validation.errors?.cash_payment}
            </p>
          </div>


          {/* amount */}
          <div>
            <label htmlFor="online_payment" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
              <span className='border bg-red-100 rounded-full p-1'>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#d0021b" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M21.65 18.65C20.55 19.75 19.03 19.75 16 19.75H8C4.97 19.75 3.44998 19.75 2.34998 18.65C1.25 17.55 1.25 15.9301 1.25 13.0002V13V11V10.9998C1.25 8.05993 1.25 6.44998 2.34998 5.35001C3.44998 4.25001 4.97 4.25 8 4.25H16C19.03 4.25 20.55 4.25001 21.65 5.35001C22.75 6.44998 22.75 8.06993 22.75 10.9998V11V13V13.0002C22.75 15.9401 22.75 17.55 21.65 18.65ZM8 5.75C7.52195 5.75 7.08752 5.75 6.69269 5.75401C6.37664 7.77652 4.77652 9.37667 2.75401 9.69272C2.75 10.0875 2.75 10.522 2.75 11V13C2.75 13.4778 2.75 13.9121 2.75401 14.3068C4.77667 14.6229 6.37688 16.2233 6.69276 18.246C7.08757 18.25 7.52198 18.25 8 18.25H16C16.4735 18.25 16.9043 18.25 17.2961 18.2461C17.5854 16.2062 19.2045 14.5904 21.246 14.3062C21.25 13.9117 21.25 13.4776 21.25 13V11C21.25 10.5206 21.25 10.0851 21.246 9.68933C19.2297 9.36307 17.627 7.75949 17.3079 5.75402C16.9129 5.75 16.4783 5.75 16 5.75H8ZM3.41003 6.41C3.76625 6.05379 4.31179 5.88983 5.15043 5.81436C4.85976 6.95737 3.95738 7.85977 2.81437 8.15045C2.88985 7.31178 3.05382 6.76622 3.41003 6.41ZM3.41003 17.59C3.05375 17.2337 2.88979 16.688 2.81433 15.8491C3.95751 16.1398 4.86 17.0424 5.15055 18.1856C4.31184 18.1102 3.76626 17.9462 3.41003 17.59ZM20.59 17.59C20.2313 17.9487 19.6807 18.1124 18.8322 18.1872C19.104 17.0257 20.0234 16.1092 21.1864 15.8414C21.1112 16.6847 20.9473 17.2326 20.59 17.59ZM20.59 6.41C20.9459 6.76592 21.1099 7.31086 21.1854 8.14834C20.0465 7.85462 19.1429 6.95143 18.8504 5.81444C19.6886 5.88994 20.2339 6.05391 20.59 6.41ZM8.25 12C8.25 14.07 9.93 15.75 12 15.75C14.07 15.75 15.75 14.07 15.75 12C15.75 9.93 14.07 8.25 12 8.25C9.93 8.25 8.25 9.93 8.25 12ZM9.75 12C9.75 10.76 10.76 9.75 12 9.75C13.24 9.75 14.25 10.76 14.25 12C14.25 13.24 13.24 14.25 12 14.25C10.76 14.25 9.75 13.24 9.75 12Z" fill="currentColor" />
                </svg>
              </span> Online Payment
            </label>
            <input
              id="online_payment"
              name="online_payment"
              type="number"
              placeholder="Enter Online Payment"
              value={formData.online_payment}
              onChange={handleChange}
              autoComplete="online_payment"
              className="block w-full mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
            <p className="text-red-600 text-sm mt-1">
              {validation.errors?.online_payment}
            </p>
          </div>

          {/* <div>
            <label htmlFor="payment_status"
              className="block text-sm font-medium text-gray-700 flex items-center gap-2"
            >

              <span className='border bg-red-100 rounded-full p-1'>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#d0021b" fill="none">
                  <defs />
                  <path fill="currentColor" d="M8.502,18.25 C8.502,18.25 8.495,18.25 8.492,18.25 C8.226,18.246 7.982,18.103 7.851,17.872 C6.173,14.936 5.015,14.771 5.002,14.77 C5.002,14.77 4.744,14.83 4.479,14.551 C4.213,14.271 4.252,13.953 4.252,13.953 C4.252,13.953 4.268,13.664 4.479,13.457 C4.69,13.25 5.002,13.25 5.002,13.25 C5.292,13.25 6.703,13.4 8.511,16.089 C10.148,13.595 14.575,7.343 18.741,5.797 C19.129,5.653 19.561,5.851 19.705,6.239 C19.849,6.627 19.651,7.059 19.263,7.203 C14.625,8.924 9.198,17.799 9.143,17.889 C9.007,18.113 8.764,18.25 8.502,18.25 Z" />
                </svg>
              </span>
              Payment Status {""}
              <span className='text-lg'> *</span>
            </label>
            <select
              id="payment_status"
              name="payment_status"
              value={formData.payment_status}
              onChange={handleChange}
              autoComplete="payment_status"
              className="block w-full mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            >
              <option>Select status</option>
              <option value="pending">Pending</option>
              <option value="complete">Complete</option>
            </select>
          </div> */}


          <div>
            <label htmlFor="amount_received" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
              <span className='border bg-red-100 rounded-full p-1'>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#d0021b" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M21.65 18.65C20.55 19.75 19.03 19.75 16 19.75H8C4.97 19.75 3.44998 19.75 2.34998 18.65C1.25 17.55 1.25 15.9301 1.25 13.0002V13V11V10.9998C1.25 8.05993 1.25 6.44998 2.34998 5.35001C3.44998 4.25001 4.97 4.25 8 4.25H16C19.03 4.25 20.55 4.25001 21.65 5.35001C22.75 6.44998 22.75 8.06993 22.75 10.9998V11V13V13.0002C22.75 15.9401 22.75 17.55 21.65 18.65ZM8 5.75C7.52195 5.75 7.08752 5.75 6.69269 5.75401C6.37664 7.77652 4.77652 9.37667 2.75401 9.69272C2.75 10.0875 2.75 10.522 2.75 11V13C2.75 13.4778 2.75 13.9121 2.75401 14.3068C4.77667 14.6229 6.37688 16.2233 6.69276 18.246C7.08757 18.25 7.52198 18.25 8 18.25H16C16.4735 18.25 16.9043 18.25 17.2961 18.2461C17.5854 16.2062 19.2045 14.5904 21.246 14.3062C21.25 13.9117 21.25 13.4776 21.25 13V11C21.25 10.5206 21.25 10.0851 21.246 9.68933C19.2297 9.36307 17.627 7.75949 17.3079 5.75402C16.9129 5.75 16.4783 5.75 16 5.75H8ZM3.41003 6.41C3.76625 6.05379 4.31179 5.88983 5.15043 5.81436C4.85976 6.95737 3.95738 7.85977 2.81437 8.15045C2.88985 7.31178 3.05382 6.76622 3.41003 6.41ZM3.41003 17.59C3.05375 17.2337 2.88979 16.688 2.81433 15.8491C3.95751 16.1398 4.86 17.0424 5.15055 18.1856C4.31184 18.1102 3.76626 17.9462 3.41003 17.59ZM20.59 17.59C20.2313 17.9487 19.6807 18.1124 18.8322 18.1872C19.104 17.0257 20.0234 16.1092 21.1864 15.8414C21.1112 16.6847 20.9473 17.2326 20.59 17.59ZM20.59 6.41C20.9459 6.76592 21.1099 7.31086 21.1854 8.14834C20.0465 7.85462 19.1429 6.95143 18.8504 5.81444C19.6886 5.88994 20.2339 6.05391 20.59 6.41ZM8.25 12C8.25 14.07 9.93 15.75 12 15.75C14.07 15.75 15.75 14.07 15.75 12C15.75 9.93 14.07 8.25 12 8.25C9.93 8.25 8.25 9.93 8.25 12ZM9.75 12C9.75 10.76 10.76 9.75 12 9.75C13.24 9.75 14.25 10.76 14.25 12C14.25 13.24 13.24 14.25 12 14.25C10.76 14.25 9.75 13.24 9.75 12Z" fill="currentColor" />
                </svg>
              </span> Amount Received
            </label>
            <input
              id="amount_received"
              name="amount_received"
              type="number"
              placeholder="Enter Amount Received"
              value={formData.amount_received}
              onChange={handleChange}
              autoComplete="amount_received"
              className="block w-full mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
            <p className="text-red-600 text-sm mt-1">
              {validation.errors?.amount_received}
            </p>
          </div>


          <div>
            <label htmlFor="total_amount" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
              <span className='border bg-red-100 rounded-full p-1'>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#d0021b" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M21.65 18.65C20.55 19.75 19.03 19.75 16 19.75H8C4.97 19.75 3.44998 19.75 2.34998 18.65C1.25 17.55 1.25 15.9301 1.25 13.0002V13V11V10.9998C1.25 8.05993 1.25 6.44998 2.34998 5.35001C3.44998 4.25001 4.97 4.25 8 4.25H16C19.03 4.25 20.55 4.25001 21.65 5.35001C22.75 6.44998 22.75 8.06993 22.75 10.9998V11V13V13.0002C22.75 15.9401 22.75 17.55 21.65 18.65ZM8 5.75C7.52195 5.75 7.08752 5.75 6.69269 5.75401C6.37664 7.77652 4.77652 9.37667 2.75401 9.69272C2.75 10.0875 2.75 10.522 2.75 11V13C2.75 13.4778 2.75 13.9121 2.75401 14.3068C4.77667 14.6229 6.37688 16.2233 6.69276 18.246C7.08757 18.25 7.52198 18.25 8 18.25H16C16.4735 18.25 16.9043 18.25 17.2961 18.2461C17.5854 16.2062 19.2045 14.5904 21.246 14.3062C21.25 13.9117 21.25 13.4776 21.25 13V11C21.25 10.5206 21.25 10.0851 21.246 9.68933C19.2297 9.36307 17.627 7.75949 17.3079 5.75402C16.9129 5.75 16.4783 5.75 16 5.75H8ZM3.41003 6.41C3.76625 6.05379 4.31179 5.88983 5.15043 5.81436C4.85976 6.95737 3.95738 7.85977 2.81437 8.15045C2.88985 7.31178 3.05382 6.76622 3.41003 6.41ZM3.41003 17.59C3.05375 17.2337 2.88979 16.688 2.81433 15.8491C3.95751 16.1398 4.86 17.0424 5.15055 18.1856C4.31184 18.1102 3.76626 17.9462 3.41003 17.59ZM20.59 17.59C20.2313 17.9487 19.6807 18.1124 18.8322 18.1872C19.104 17.0257 20.0234 16.1092 21.1864 15.8414C21.1112 16.6847 20.9473 17.2326 20.59 17.59ZM20.59 6.41C20.9459 6.76592 21.1099 7.31086 21.1854 8.14834C20.0465 7.85462 19.1429 6.95143 18.8504 5.81444C19.6886 5.88994 20.2339 6.05391 20.59 6.41ZM8.25 12C8.25 14.07 9.93 15.75 12 15.75C14.07 15.75 15.75 14.07 15.75 12C15.75 9.93 14.07 8.25 12 8.25C9.93 8.25 8.25 9.93 8.25 12ZM9.75 12C9.75 10.76 10.76 9.75 12 9.75C13.24 9.75 14.25 10.76 14.25 12C14.25 13.24 13.24 14.25 12 14.25C10.76 14.25 9.75 13.24 9.75 12Z" fill="currentColor" />
                </svg>
              </span>Pending Amount
            </label>
            <input
              id="pending_amount"
              name="pending_amount"
              type="number"
              placeholder="Enter Pending Amount "
              value={formData.pending_amount}
              onChange={handleChange}
              autoComplete="pending_amount"
              className="block w-full mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
            <p className="text-red-600 text-sm mt-1">
              {validation.errors?.pending_amount}
            </p>
          </div>






        </div>

        {/* Submit Button */}
        <div className="mt-6 text-right">
          <button
            type="submit"
            className="inline-flex items-center gap-2 px-6 py-2 bg-indigo-600 text-white text-sm font-medium rounded-md shadow hover:bg-indigo-700 transition-all"
          >
            Save
          </button>
        </div>
      </form>

    </div>
  )
}

export default ChitDetailsEdit
